import React, { useState, useEffect } from "react"
import { navigate } from "gatsby"
import { FormikWizard } from "formik-wizard"
import { useToasts } from "react-toast-notifications"
import CheckedIcon from "../../../images/icons/checked.svg"
import FailIcon from "../../../images/icons/failed.svg"
import IncorpIcon from "../../../images/business/company-incor.svg"

import steps from "./steps"
import CompanyRegistrationWrapper from "../startCompanyRegistration/CompanyRegistrationWrapper"
import Summary from "./views/Summary"
import BusinessTitleCard from "../BusinessCardTitle"
import ConfirmModal from "../ConfirmModal"
import ResponseModal from "../ResponseModal"
// import Shareholders from "./views/Shareholders"

const StartApplication = () => {
  const [companyIncorfees, setCompanyIncorfees] = useState("55,000")
  const { addToast } = useToasts()
  const [shareholders, setShareholders] = useState([])
  const [loading, setLoading] = useState(false)

  const [showSummary, setShowSummary] = useState(false)
  const [accountNo, setAccountNo] = useState("")
  const [data, setData] = useState({})
  const [popup, setPopup] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [openDoneModal, setOpenDoneModal] = useState(false)
  const [openFailModal, setFailModal] = useState(false)

  // Submit Data
  const handleSubmit = (values) => {
    setShowSummary(true)
    setData(values)
    const formdata = JSON.parse(localStorage.getItem("formDataArray")) || []
    setShareholders(formdata)
  }

  const createRecord = async () => {
    setBtnLoading(true)
    let business_info = data.business_info
    let shareholder_info = data.shareholder_info
    let presenter_info = data.presenter_info

    const combinedData = {
      ...business_info,
      ...shareholder_info,
      ...presenter_info,
      shareholders: shareholders,
    }

    try {
      const response = await fetch(
        `${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/business/web/registration/company-incorporation`,
        {
          method: "POST",
          body: JSON.stringify(combinedData),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: localStorage.getItem("mobile_token"),
          },
        }
      )
      if (!response.ok) {
        throw new Error(`HTTP error ! Status: ${response.status} `)
      }
      setBtnLoading(false)
      setOpenDoneModal(true)

      localStorage.clear()
      // const data = await response.json()
      // console.log('data:', data)
    } catch (err) {
      if (err.response.data.message === "Token expired") {
         addToast(`${err.response.data.message}, try again`, {
           appearance: "error",
           placement: "top-center",
           autoDismiss: true,
         })
        navigate("/business-support/get-started/")
         localStorage.clear()
      }
      setBtnLoading(false)
      setFailModal(true)
    }
  }
  const initPayment = async () => {
    setPopup(true)
  }
  const hidePopup = () => {
    setPopup(false)
  }
  const goback = () => {
    setOpenDoneModal(false)
    navigate("/business-support/get-started")
  }
  const backToSummary = () => {
    setFailModal(false)
    setPopup(true)
  }

  useEffect(() => {
    const storedData = localStorage.getItem("supportFees")

    if (storedData) {
      // Convert the JSON string back to an object
      const parsedData = JSON.parse(storedData)
      setCompanyIncorfees(parsedData)
    } else {
      console.log("No data found in localStorage.")
    }
  }, [])
  useEffect(() => {
    const account_no = localStorage.getItem("nuban_id_24b854967")
    if (account_no) {
      setAccountNo(account_no)
    }
  })
  return (
    <div>
      <div className={!showSummary ? "container" : "container d-none"}>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <BusinessTitleCard
              icon={IncorpIcon}
              title="Company incorporation"
              subtitle="Officially register your company or in corporation, get CAC and a TIN"
            />
            <div className="business-suport-card my-lg-5 waitlist__form ">
              <FormikWizard
                steps={steps}
                onSubmit={handleSubmit}
                render={CompanyRegistrationWrapper}
              />
            </div>
          </div>
        </div>
      </div>
      <ConfirmModal
        show={popup}
        closePopup={hidePopup}
        handlePayment={createRecord}
        btnLoader={btnLoading}
        account_no={accountNo}
        amount={companyIncorfees.companyIncorporation}
      />
      <ResponseModal
        text1="Your payment for your Sparkle business support service was successful!"
        text2="Your application is on the way and we would get back to you 
        in 24-48 hours."
        title="Payment Successful"
        icon={CheckedIcon}
        show={openDoneModal}
        btnAction={goback}
        btnText="Done"
      />
      <ResponseModal
        text1="Your payment for your Sparkle business support service was unsuccessful!"
        text2="Kindly try again"
        title="Payment unsuccessful"
        icon={FailIcon}
        show={openFailModal}
        btnAction={backToSummary}
        btnText="Try Again"
      />

      {showSummary && (
        <Summary
          businessData={data}
          shareholders={shareholders}
          payFee={initPayment}
          setShowSummary={setShowSummary}
          setLoading={setLoading}
          amount={companyIncorfees.companyIncorporation}
          loadingStatus={loading}
        />
      )}
    </div>
  )
}

export default StartApplication
